import { render, staticRenderFns } from "./NewProcessstep.vue?vue&type=template&id=7b6795ac&"
import script from "./NewProcessstep.vue?vue&type=script&lang=js&"
export * from "./NewProcessstep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProcessstep.vue"
export default component.exports